/*
 * $Id:: ApiError.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

export default class ApiError extends Error {
    constructor({ code, message, details, ...rest }) {
        super(message || '');
        this.name = 'ApiError';
        this.code = code || 500;
        this.details = details || '';
        this.extraInfo = rest || {};

        this.isApiError = true;
    }
}
